import { useResource } from '@pankod/refine-core';
import { PageLayout } from 'components/PageLayout';
import { ShowDetails } from 'pages/products/ShowDetails';

export const Show: React.FC = () => {
  const { id } = useResource();

  return (
    <PageLayout withBackButton title="Product details">
      <ShowDetails id={id} />
    </PageLayout>
  );
};
